/** Product name — rebrand by changing this single constant. */
export const APP_NAME = 'Brain';

/** API base — empty string = same origin (works with Vite proxy in dev, same-origin in prod). */
export const API_BASE = '';

/** Shared Brain WhatsApp number, injected via env; empty = not shown (backend does not expose it yet). */
export const BRAIN_WHATSAPP_NUMBER =
  (import.meta.env.VITE_BRAIN_WHATSAPP_NUMBER as string | undefined)?.trim() ?? '';

/** Poll interval for wizard status (ms). */
export const STATUS_POLL_INTERVAL_MS = 3_000;

/** IANA timezones (runtime; graceful fallback to empty list if not supported). */
export const IANA_TIMEZONES: string[] = (() => {
  try {
    return (
      (Intl as { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf?.('timeZone') ??
      []
    );
  } catch {
    return [];
  }
})();
